export default "__VITE_ASSET__0xLA4iP7__"